module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_2"
    }
  }, [_c('span', [_vm._v("Bad to Be Merry")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("by Andrew Grey")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Former mobster Richard Marsden grew up scrounging on the streets of Detroit. This Christmas, for the first time, he has a family and the means to provide an abundant Christmas, and that’s what he intends to do.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But his husband, Daniel, grew up with everything. For Daniel, Christmas isn’t about receiving gifts, but the opportunity to help others. With his son in the hospital recovering from a tonsillectomy, Daniel knows just who he wants to help this year.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Both Daniel and Richard make plans for their family Christmas assuming the other is on board, leaving their holiday dangling on the precipice of disaster—unless they can remember that family, love, and the holidays mean compromising to give each other what they need. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7a48bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0